const CheckCircleIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#CBC646"></circle>
      <path d="M6.85547 12.5718L10.284 16.0004L16.7986 7.67993" stroke="black"></path>
    </svg>
  );
};

export default CheckCircleIcon;
